<template>
  <!--listBody-->
  <div class="content">
    <div class="condition">
      <div class="check_wrap">
        <el-radio-group v-model="listData.type" @change="radioChange" size="small">
          <el-radio-button label="0">全部</el-radio-button>
          <el-radio-button label="1">公司</el-radio-button>
          <el-radio-button label="2">个人</el-radio-button>
        </el-radio-group>
      </div>
      <div class="search_wrap">
        <el-form :inline="true" :model="listData" class="form-inline">
          <el-form-item>
            <el-date-picker
                    v-model="dataTime"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="small"
                    :picker-options="pickerOptions1"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input v-model="listData.name" placeholder="请输入姓名查找" size="small">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="listData.keyword" placeholder="请输入关键词查找" size="small">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchFn" size="small"></el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--      <el-button type="primary" @click="publish('add')">发布企业动态</el-button>-->
      <div class="other_wrap">
        <el-button type="primary" @click="publish('add')" size="small">发布企业动态</el-button>
      </div>
    </div>
    <div>
      <div class="other_wrap mb-20 infoBody">
        个人动态展示:
        <el-switch
                class="ml10"
                v-model="switch_structure"
                active-color="#2AA3F8"
                inactive-color="#ddd"
                @change="changeswitch()"
        ></el-switch>
        <el-tooltip class="item" effect="light" placement="bottom-start">
          <div slot="content" class="infocontent">
            <p>个人动态的发布与展示</p>
          </div>
          <i class="iconfont iconbangzhu1"></i>
        </el-tooltip>
      </div>
    </div>
    <div class="table_wrap">
      <el-table :data="activeList" style="width: 100%">
        <!--        <el-table-column prop="date" type="selection"></el-table-column>-->
        <el-table-column prop="date" label="发布人">
          <template slot-scope="scope">{{scope.row.user_name}}</template>
        </el-table-column>
        <el-table-column label="内容">
          <template slot-scope="scope">
            <div class="contentBox">
              <div class="titleList">{{scope.row.biref}}</div>
              <p @click="privaImgFn(scope.$index)"><i class="el-icon-picture-outline"></i>查看动态图片({{scope.row.num}})</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="所属栏目">
          <template slot-scope="scope">
<!--            // <span v-if="scope.row.type==0">支持企业动态和个人动态</span>-->
<!--            //         <span v-if="scope.row.type==1">仅支持企业动态</span>-->
<!--            //         <span v-if="scope.row.type==2">仅支持个人动态</span>-->
            <div v-if="scope.row.type==0">
            <el-select v-model="scope.row.pro_id" placeholder="请选择栏目" @change="changeLine($event,scope.$index)"
                       size="small">
              <template v-for="(item,index) in optionList">
                <el-option
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        v-if="index==0||item.type==2||item.type==0"
                ></el-option>              
              </template>         
            </el-select>
            </div>
            <div v-if="scope.row.type==1||scope.row.type==2 ">
              <el-select v-model="scope.row.pro_id" placeholder="请选择栏目" @change="changeLine($event,scope.$index)"
                         size="small">
                <template v-for="(item,index) in optionList">        
                  <el-option  
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          v-if="index==0||item.type==scope.row.type||item.type==0"
                  ></el-option>
                </template> 
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sub_time" label="发布时间" width="130"></el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.type==1">
              <el-button type="text" size="small" @click="cancelRecommend(scope.row.id,scope.$index)" v-if="scope.row.recommend==1">取消置顶</el-button>
              <el-button type="text" size="small" @click="addRecommend(scope.row.id,scope.$index)" v-else>置顶</el-button>
            </template>
            <el-button type="text" size="small" @click="publish('edit',scope.$index)">编辑</el-button>
            <el-button type="text" size="small" @click="detelLine(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag_wrap">
        <el-pagination
                background
                :page-size="page.pagesize"
                :current-page="page.pageindex"
                layout="total, prev, pager, next"
                :total="page.total"
                @current-change="pageIndexChange"></el-pagination>
      </div>
    </div>
    <!--    图片弹窗-->
    <previewImgDialog title="动态图片" :privaImgObj="privaImgObj" :visible.sync="dialogImgVisible"></previewImgDialog>
  </div>
</template>
<script>
  import previewImgDialog from "@/components/dialog/previewImgDialog.vue";
  import {yeartime, yeartime_} from '@/assets/js/common'
  import {pagination} from "@/util/util.js";
  import api from "@/api.js"

  export default {
    name: "listPannel",
    props: ["pageStatus"],
    components: {
      previewImgDialog
    },
    data() {
      return {
        pickerOptions1: {
          disabledDate(time) {
            return time.getTime() > Date.now(); //  - 8.64e7 减去就是不包含今天的
          },
        },
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        // 页面数据
        activeList: [], // 列表总页数
        listData: {
          type: 0, // 当前类型 0全部、1公司、2个人
          name: '', // 搜索得名字
          start_time: '', // 开始日期(时间戳)
          end_time: '', // 结束日期(时间戳)
          keyword: '', // 关键词查找
        }, // 列表数据
        optionList: [],
        dialogImgVisible: false,
        privaImgObj: [],
        dataTime: [],
        switch_structure:false
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      selectlist() {
        // 所属栏目
        this.axios
            .post('companyadmin/programa', {})
            .then(response => {
              if (response.data.code == 0) {
                response.data.list.unshift({name: '全部', id: 0})
                // <span v-if="scope.row.type==0">支持企业动态和个人动态</span>
                //         <span v-if="scope.row.type==1">仅支持企业动态</span>
                //         <span v-if="scope.row.type==2">仅支持个人动态</span>
                this.optionList = response.data.list
              } else {
              }
            })
            .catch(response => {
            });
      },
      InitFn() {
        // page 	整型 	必填 	- 	- 	页码
        // type 	整型 	非必填 	- 	- 	查看类型(0全部、1公司、2个人)
        // name 	varchar 	非必填 	- 	- 	姓名查找
        // start_time 	varchar 	非必填 	- 	- 	开始日期(时间戳)
        // end_time 	varchar 	非必填 	- 	- 	结束日期(时间戳)
        // keyword 	varchar 	非必填 	- 	- 	关键词查找
        this.listData.page = this.page.pageindex
        this.axios
            .post(api.diary_index, this.listData)
            .then(response => {
              if (response.data.code == 0) {
                for (let i in  response.data.list) {
                  let pic_ = response.data.list[i].pic
                  if (response.data.list[i].pic) {
                    let pic_num = pic_.split(',')
                    response.data.list[i].num = pic_num.length
                  } else {
                    response.data.list[i].num = 0
                  }
                  response.data.list[i].sub_time = yeartime(response.data.list[i].sub_time)
                }
                // 个人动态开关（0关闭、1开启）
                let switch_structure = false
                if(response.data.dynamic_person===1){
                  switch_structure = true
                }
                // "type":"发布类型(0个人、1公司)",
                // optionList 0支持企业动态个人 1仅支持企业 2 仅支持个人动态、

                this.switch_structure = switch_structure
                this.activeList = response.data.list
                this.page.total = response.data.all_page
                this.selectlist();
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 分页
      pageIndexChange(pageindex) {
        this.page.pageindex = pageindex;
        this.InitFn();
      },
      searchFn() {
        this.listData.page = 1
        if (this.dataTime) {
          if (this.dataTime.length !== 0) {
            this.listData.start_time = yeartime_(this.dataTime[0])
            this.listData.end_time = yeartime_(this.dataTime[1])
          } else {
            this.listData.start_time = ''
            this.listData.end_time = ''
          }
        } else {
          this.listData.start_time = ''
          this.listData.end_time = ''
        }
        this.InitFn()
      },

      publish(option, index) {
        let self_ = this
        if (option === 'edit') {
          // dynamic_type: 0, // 	整型 	必填 	- 	- 	动态类型(0文章、1图文)
          // let dynamic_type = 'article'
          let dynamic_type = 1
          if (Number(self_.activeList[index].dynamic_type) === 1) {
            dynamic_type = 2
          }
       
          this.$router.push({
              name: "momentsEdit",
              query: {id: self_.activeList[index].id, dynamic_type: dynamic_type, pageType: option, programaType: 1}
            });

        } else {
          this.$router.push({name: "momentsEdit", query: {pageType: option, programaType: 1}});
        }
      },
      //置顶
      addRecommend(id,index) {
        this.axios
            .post('companyadmin/diary/addRecommend ', {diary_id: id})
            .then(response => {
              if (response.data.code == 0) {
                this.activeList[index].recommend = 1;
                this.$message({
                  message: '设置成功'
                });
              } else {
                this.$message.error('设置失败');
              }
            })
            .catch(response => {
            });
      },
      cancelRecommend(id,index) {
        this.axios
            .post('companyadmin/diary/cancelRecommend ', {diary_id: id})
            .then(response => {
              if (response.data.code == 0) {
                this.activeList[index].recommend = 0;
                this.$message({
                  message: '设置成功'
                });
              } else {
                this.$message.error('设置失败');
              }
            })
            .catch(response => {
            });
      },
      searchActive(option) {
      },
      radioChange(option) {
        // 选择radio
        this.listData.type = option
        this.listData.page = 1
        this.InitFn()
      },
      // 更改select
      changeLine(e, index) {
        let data_ = {}
        for(let i in this.activeList[index]){
          if(i=='pic'){
            let picSrc = this.activeList[index][i];
            data_['pic'] = picSrc.split(',')
          }else{
            data_[i] = this.activeList[index][i]
          }
        }
        data_.diary_id = this.activeList[index].id
        data_.pro_id = e
        data_.is_sub = 1
        this.axios
            .post('companyadmin/diary/edit', data_)
            .then(response => {
              if (response.data.code == 0) {
              } else {
                this.$message.error('设置失败');
              }
            })
            .catch(response => {
            });
      },
      detelLine(index) {
        let self_ = this
        this.$confirm('是否删除该动态?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          self_.axios
              .post('companyadmin/diary/delete', {diary_id: self_.activeList[index].id})
              .then(response => {
                if (response.data.code == 0) {
                  self_.InitFn()
                  self_.activeList.splice(index, 1)
                  self_.$message({
                    message: '删除成功!'
                  });
                } else {
                }
              })
              .catch(response => {
              });
        }).catch(() => {
        });
      },
      privaImgFn(index) {
        if (this.activeList[index].num === 0) {
          this.$message({
            message: '没有可查看的图片',
            type: 'warning'
          });
          return
        }
        this.privaImgObj = this.activeList[index].pic.split(',')
        this.dialogImgVisible = true
      },
      changeswitch() {
        const loading = this.$loading({
          lock: true,
          text: '设置中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        let switch_structure = 0;
        if(this.switch_structure){
          switch_structure = 1;
        }
        this.axios
            .post(api.diary_person, {dynamic_person:switch_structure})
            .then(response => {
              if (response.data.code == 0) {
                setTimeout(()=>{
                  loading.close();
                },300)
              } else {
              }
            })
            .catch(response => {
            });
      }
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      pageStatus: {
        immediate: true,
        handler(val) {
          this.InitFn()
        }
      }
    }
  };
</script>
